import { InventarioAvanzado, InventarioSimple } from "../../components";
import { useAuthContext } from "../../context/auth";
import "./stylesInventarioNuevo.scss";

export const InventarioNuevo = () => {
  const { pais } = useAuthContext();

  return <>{pais === "Perú" || pais === "Uruguay" ? <InventarioSimple /> : <InventarioAvanzado />}</>;
};
